import Main from "../layout/Main";
import Home from "../pages/Home";
import WorkPage from "../pages/WorkPage";
import ServicesPage from "../pages/ServicesPage";
import ContactPage from "../pages/ContactPage";
import StartProjectPage from "../pages/StartProjectPage";
import BlogPage from "../pages/BlogPage";
import ProjectArchive from "../pages/ProjectArchive";
// --- IMPORT THE NEW PAGE ---
import BlogDetails from "../pages/BlogDetails";

import AdminHome from "../adminPages/AdminHome";
import Dashboard from "../layout/Dashboard";
import CreatePost from "../adminPages/CreatePost";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/work', element: <WorkPage /> },
      { path: '/service', element: <ServicesPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/startProject', element: <StartProjectPage /> },
      {
        path: '/caseStudies',
        element: <BlogPage />
      },
      {
        // Change this path to match what you are typing in the browser
        path: '/blog/:slug',
        element: <BlogDetails />
      },
      { path: '/archive', element: <ProjectArchive /> },
    ]
  },

  {
    path: "/admin-portal",
    element: <Dashboard />,
    children: [
      { index: true, element: <AdminHome /> },
      { path: "create-post", element: <CreatePost /> },
      { path: "messages", element: <div className="text-white font-mono">// Inbox Feed...</div> }
    ]
  }
]);

export default router;